import { DotsThreeVertical, DownloadSimple, Info, PencilSimple, Trash } from 'phosphor-react';

function StorageItemActionsMenu({ item, isOpen, setOpenItemMenuId, itemMenuRef, onDownload, onRename, onProperties, onDelete }) {
  return (
    <div className="relative" ref={isOpen ? itemMenuRef : null}>
      <button
        type="button"
        onClick={() => setOpenItemMenuId((prev) => (prev === item.id ? '' : item.id))}
        className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-100"
        aria-label="Open item actions"
        title="Actions"
      >
        <DotsThreeVertical size={16} weight="bold" />
      </button>
      {isOpen && (
        <div className="absolute right-0 z-20 mt-1 w-44 rounded-xl border border-slate-200 bg-white p-1 shadow-lg">
          {item.type === 'file' && (
            <button
              type="button"
              onClick={() => {
                setOpenItemMenuId('');
                onDownload(item);
              }}
              className="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-slate-700 transition hover:bg-slate-100"
            >
              <DownloadSimple size={14} weight="bold" />
              Download
            </button>
          )}
          <button
            type="button"
            onClick={() => {
              setOpenItemMenuId('');
              onRename(item);
            }}
            className="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-slate-700 transition hover:bg-slate-100"
          >
            <PencilSimple size={14} weight="bold" />
            Rename
          </button>
          <button
            type="button"
            onClick={() => {
              setOpenItemMenuId('');
              onProperties(item);
            }}
            className="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-slate-700 transition hover:bg-slate-100"
          >
            <Info size={14} weight="bold" />
            Properties
          </button>
          <button
            type="button"
            onClick={() => {
              setOpenItemMenuId('');
              onDelete(item);
            }}
            className="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-red-700 transition hover:bg-red-50"
          >
            <Trash size={14} weight="bold" />
            Delete
          </button>
        </div>
      )}
    </div>
  );
}

export default StorageItemActionsMenu;
